import React from "react";
import {
  ChatContainer,
  ConversationHeader,
  MessageList,
  Avatar,
  MainContainer,
} from "@chatscope/chat-ui-kit-react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  Avatar as MuiAvatar,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  ListItemSecondaryAction,
  TextField,
  Slide,
  Toolbar,
  ListSubheader,
  useMediaQuery
} from "@material-ui/core";
import {
  Group,
  RemoveCircleOutline,
  PersonAdd,
  GroupAdd,
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
// import { firebaseConfig as firebase } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import MessageBar from "./MessageBar";
import { EmojipickerProvider } from "../contexts/EmojiPickerContext";
import firebase from "firebase/app";
import "firebase/firestore";
import { useHistory, useParams } from "react-router-dom";
import MessageFeed from "./MessageFeed";
import { useSnackbar } from "notistack";
import Autocomplete from "@material-ui/lab/Autocomplete";
import EditGroupDetails from "./EditGroupDetails";
import AvatarBadge from "./AvatarBadge";
import { useTheme } from "@material-ui/core/styles";

const useStyle = makeStyles((theme) => ({
  center: {
    marginTop: "200px",
    marginLeft: "50%",
    marginRight: "50%",
  },
  messageBar: {
    paddingTop: theme.spacing(10),
  },
  chatContainer: {
    paddingTop: theme.spacing(5),
  },
}));
const db = firebase.firestore();
let senders = [];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ParticipentsDialog({ chat, open, handleClose }) {
  const { currentUser } = useAuth();
  const [participents, setParticipents] = React.useState([]);
  const [participentRemoved, setParticipentRemove] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const fetchParticipents = () => {
    let participents = [];
    db.collection("users")
      .where("uid", "in", chat.participents)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          participents.push(doc.data());
        });
        setParticipents(participents);
        senders = participents;
      });
      
    return participents;
  };

  const handleRemove = (user) => {
    // setLoading(true);
    db.collection("rooms")
      .doc(chat.roomID)
      .update({
        participents: firebase.firestore.FieldValue.arrayRemove(user.uid),
      })
      .then(() => {
        // setLoading(false);
        setParticipentRemove(true);
        // handleClose()
      });
  };


  React.useEffect(async () => {
    fetchParticipents()
  }, [participentRemoved]);

  // const isPerticipentCurrentUser = (user) => {
  //  if (currentUser.uid === user.uid) {
  //    return true
  //  } else {
  //    return false
  //  }
  // }

  return (
    <Dialog fullWidth fullScreen={fullScreen} maxWidth="xs" open={open} TransitionComponent={Transition}>
      <DialogTitle id="confirmation-dialog-title">
        <Toolbar>
          Chat participents
          {loading ? <CircularProgress size="1rem" /> : ""}
        </Toolbar>
      </DialogTitle>
      <DialogContent dividers>
        <EditGroupDetails chat={chat} />  {/* edit group details form */}
        <List subheader={<ListSubheader>Members</ListSubheader>}>
          {participents.map((user, index) => (
            <ListItem key={index}>
              <ListItemAvatar>
                <AvatarBadge userId={user.uid} src={user.photoURL} alt={user.displayName}>{user.displayName[0]}</AvatarBadge>
              </ListItemAvatar>
              <ListItemText>{user.displayName}</ListItemText>
              <ListItemSecondaryAction>
                <IconButton edge="end" onClick={() => handleRemove(user, chat)}>
                  <RemoveCircleOutline />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="default" onClick={handleClose}>
          close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const AddParticipentsDialog = ({ open, handleClose, chat }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setloading] = React.useState(false);
  const [participents, setParticipents] = React.useState([]);
  const [options, setOptions] = React.useState([]);
  const { currentUser } = useAuth();

  const addParticipents = () => {
    let members = [];
    participents.forEach((user) => {
      members.push(user.uid);
    });
    setloading(true);
    db.collection("rooms")
      .doc(chat.roomID)
      .update({
        participents: firebase.firestore.FieldValue.arrayUnion(...members),
      })
      .then(() => {
        enqueueSnackbar("Participent added!", { variant: "info" });
        setloading(false);
        handleClose();
      })
      .catch((error) => {
        enqueueSnackbar("sorry something went wrong!", {
          variant: "error",
        });
        setloading(false);
        handleClose();
      });
  };

  const fetchParticipents = (email) => {
    db.collection("users")
      .where("email", "==", email)
      .where("email", "!=", currentUser.email)
      .get()
      .then((querySnapshot) => {
        const participents = [];
        querySnapshot.forEach((doc) => {
          participents.push(doc.data());
          setOptions([...options, doc.data()]);
        });
      });
    return participents;
  };

  return (
    <Dialog fullWidth={true} maxWidth="xs" open={open}>
      <DialogTitle>Add Participents</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <CircularProgress />
        ) : (
          <Autocomplete
            multiple
            id="tags-standard"
            options={options}
            getOptionLabel={(user) => user.email}
            onChange={(e, value) => setParticipents(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                onChange={(e) => fetchParticipents(e.target.value)}
                variant="outlined"
                label="Add participents"
                placeholder="Emails"
              />
            )}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="text">
          cancel
        </Button>
        <Button variant="outlined" color="primary" onClick={addParticipents}>
          ADD
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// main component
export function Chatfeed({ chatData }) {
  const classes = useStyle();
  const [loading, setLoading] = React.useState(false);
  const [messages, setMessages] = React.useState([]);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [pDialogOpen, setPDialogOpen] = React.useState(false);

  const fetchMessages = () => {
    setLoading(true);
    db.collection("messages")
      .where("roomID", "==", chatData.roomID)
      .orderBy("time", "asc")
      .onSnapshot((querySnapshot) => {
        const msg = [];
        querySnapshot.forEach((doc) => {
          msg.push(doc.data());
        });
        setMessages(msg);
        setLoading(false);
      });
  };

  React.useEffect(() => {
    fetchMessages();
  }, []);

  return loading ? (
    <div className={classes.center}>
      <CircularProgress />
    </div>
  ) : (
    <div>
      <div style={{ height: "100vh", maxHeight: "100vh" }}>
        <MainContainer>
          <ChatContainer>
            <ConversationHeader>
              <Avatar
                src={
                  chatData.photoURL === ""
                    ? `https://via.placeholder.com/50?text=${chatData.name[0]}`
                    : chatData.photoURL
                }
                name={chatData.name}
              />
              <ConversationHeader.Content
                userName={chatData.name}
                info={chatData.participents.length + " participents"}
              />
              <ConversationHeader.Actions>
                <IconButton onClick={() => setPDialogOpen(true)}>
                  <PersonAdd />
                </IconButton>
                <IconButton onClick={() => setDialogOpen(true)}>
                  <Group />
                </IconButton>
              </ConversationHeader.Actions>
            </ConversationHeader>

            <MessageList>
              <MessageList.Content>
                <MessageFeed messages={messages} senders={senders} />
              </MessageList.Content>
            </MessageList>
          </ChatContainer>
        </MainContainer>
      </div>
      <div className={classes.messageBar}>
        <EmojipickerProvider>
          <MessageBar roomID={chatData.roomID} />
        </EmojipickerProvider>
      </div>
      <AddParticipentsDialog
        chat={chatData}
        open={pDialogOpen}
        handleClose={() => setPDialogOpen(false)}
      />
      <ParticipentsDialog
        handleClose={() => setDialogOpen(false)}
        open={dialogOpen}
        chat={chatData}
      />
    </div>
  );
}

export function MobileChatfeed() {
  const classes = useStyle();
  let { roomID } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [messages, setMessages] = React.useState([]);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [pDialogOpen, setPDialogOpen] = React.useState(false);
  const [chatData, setChatData] = React.useState({});
  const [checked, setChecked] = React.useState(false);

  React.useEffect(() => {
    setChecked(true);
    db.collection("rooms")
      .doc(roomID)
      .get()
      .then((doc) => {
        if (doc.exists) {
          db.collection("messages")
            .where("roomID", "==", doc.data().roomID)
            .orderBy("time", "asc")
            .onSnapshot((querySnapshot) => {
              const msg = [];
              querySnapshot.forEach((doc) => {
                msg.push(doc.data());
              });
              setMessages(msg);
              setLoading(false);
            });
          setChatData(doc.data());
        }
      });
  }, []);

  let history = useHistory();

  const handleBackArrow = () => {
    setChecked(false);
    history.goBack();
  };

  return loading ? (
    <Slide in={checked} direction="up" mountOnEnter unmountOnExit>
      <div className={classes.center}>
        <CircularProgress />
      </div>
    </Slide>
  ) : (
    <Slide in={checked} direction="up" mountOnEnter unmountOnExit>
      <div>
        <div style={{ height: "80vh" }}>
          <MainContainer>
            <ChatContainer>
              <ConversationHeader>
                <ConversationHeader.Back onClick={handleBackArrow} />
                <Avatar
                  src={
                    chatData.photoURL === ""
                      ? `https://via.placeholder.com/50?text=${chatData.name[0]}`
                      : chatData.photoURL
                  }
                  name={chatData.name}
                />
                <ConversationHeader.Content
                  userName={chatData.name}
                  info={chatData.participents.length + " participents"}
                />
                <ConversationHeader.Actions>
                  <IconButton onClick={() => setPDialogOpen(true)}>
                    <GroupAdd />
                  </IconButton>
                  <IconButton onClick={() => setDialogOpen(true)}>
                    <Group />
                  </IconButton>
                </ConversationHeader.Actions>
              </ConversationHeader>
              <MessageList>
                <MessageList.Content>
                  <MessageFeed messages={messages} senders={senders} />
                </MessageList.Content>
              </MessageList>
            </ChatContainer>
          </MainContainer>
        </div>
        <div className={classes.messageBar}>
          <EmojipickerProvider>
            <MessageBar roomID={chatData.roomID} mobileDevice={true} />
          </EmojipickerProvider>
        </div>
        <AddParticipentsDialog
          chat={chatData}
          open={pDialogOpen}
          handleClose={() => setPDialogOpen(false)}
        />
        <ParticipentsDialog
          handleClose={() => setDialogOpen(false)}
          open={dialogOpen}
          chat={chatData}
        />
      </div>
    </Slide>
  );
}
